import { IComponentOptions } from 'angular';
import template from './tn-checkboxes.html';

export interface TnCheckboxesOption<T = number> {
    label: string;
    value: T;
    count: number;
}

// this is a dumb component it doesn't track it's own selected state. It relies on the parent to pass in the selected state
// it's onChange handler will provide the selection on changes.
export class TnCheckboxesController<T = number> {
    public options: TnCheckboxesOption<T>[] = [];
    public selected: T[] = [];
    public onChange?: (args: { selected: T[] }) => void;

    toggle(option: TnCheckboxesOption<T>): void {
        const selected = this.isSelected(option)
            ? this.selected?.filter((v) => v !== option.value)
            : [...this.selected, option.value];
        this.onChange && this.onChange({ selected });
    }

    isSelected(option: TnCheckboxesOption<T>): boolean {
        const is = this.selected?.includes(option.value);
        return is;
    }
}

export const TnCheckboxesComponent: IComponentOptions = {
    controller: TnCheckboxesController,
    template,
    bindings: {
        options: '<',
        selected: '<',
        onChange: '&',
    },
    transclude: {
        help: '?help',
        title: '?title',
    },
};
